module.exports = __webpack_public_path__ + "img/reg-m.dc350ea1.jpg";